module.exports = __webpack_public_path__ + "57ab770d8ac3860aa5036e0828606a4f.pdf";